import { Collapsible, Flex, Heading, Text } from '@buffer-mono/popcorn'

import type {
  ChannelScoreDetails,
  CommentsScoreSummary,
} from '../../hooks/scoring/useCommentsScore'

import { CommentScoreMetric } from '../../components/CommentScoreMetric'
import { DetailedMetrics } from '../../components/DetailedMetrics'

import styles from './ScoreContent.module.css'

import type { JSX } from 'react'

const CommentsScoreHeader = ({
  isAllChannels,
}: {
  isAllChannels: boolean
}): JSX.Element => {
  return (
    <header className={styles.header}>
      <Heading size="md" className={styles.headerTitle}>
        {isAllChannels
          ? 'Avg. Comment score for all your Channels'
          : 'Comment score'}
      </Heading>
      <Text size="sm" color="subtle">
        Tracks how you reply to, resolve, and like comments across{' '}
        {isAllChannels ? 'all your' : 'your'} channels.
      </Text>
    </header>
  )
}

export const ScoreContent = ({
  commentsScore,
  isAllChannels = false,
}: {
  commentsScore: ChannelScoreDetails | CommentsScoreSummary
  isAllChannels?: boolean
}): JSX.Element => {
  return (
    <article className={styles.cardContainer}>
      <CommentsScoreHeader isAllChannels={isAllChannels} />
      <section className={styles.body}>
        <div className={styles.bodyWrapper}>
          <div className={styles.scoreColumn}>
            <CommentScoreMetric
              level={commentsScore.currentAchievementLevel.label}
              score={commentsScore.currentPeriodScore.totalValue}
            />
          </div>
          <Flex
            direction="column"
            gap="lg"
            justify="start"
            className={styles.metricsColumn}
          >
            <DetailedMetrics
              responseRate={commentsScore.currentPeriodScore.responseRate}
              responseSpeed={commentsScore.currentPeriodScore.responseSpeed}
              consistency={commentsScore.currentPeriodScore.consistency}
            />
            <Collapsible>
              <Collapsible.Trigger className={styles.calculateTrigger}>
                <Text size="sm" color="subtle">
                  How we calculate it
                </Text>
              </Collapsible.Trigger>
              <Collapsible.Content>
                <Text size="sm" color="subtle">
                  Comment score is calculated weekly from response rate (50%),
                  speed (30%), and consistency (20%). Mentions don&apos;t count.
                </Text>
              </Collapsible.Content>
            </Collapsible>
          </Flex>
        </div>
      </section>
    </article>
  )
}
